import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_DISHES,
  REQUEST_CREATE_MASTER_DISHES,
  SET_MASTER_DISHES,
  SUCCESS_CREATE_MASTER_DISHES,
  ERROR_GET_MASTER_DISHES,
  ERROR_CREATE_MASTER_DISHES,
  SUCCESS_DELETE_MASTER_DISHES,
  SUCCESS_UPDATE_MASTER_DISHES,
  REQUEST_DELETE_MASTER_DISHES,
  REQUEST_UPDATE_MASTER_DISHES,
  ERROR_DELETE_MASTER_DISHES,
  ERROR_UPDATE_MASTER_DISHES,
} from "./dishesActionTypes";

function* requestMasterDishes(action: Record<string, any>): any {
  try {
    const result: any = yield call(getDishesMaster);
    yield put({ type: SET_MASTER_DISHES, payload: result.data.data });
    // console.warn(result.data.data, "jhuihihi");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_DISHES, payload: message });
  }
}

function* requestUpdateMasterTagDishes(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterDishes,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_DISHES,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_DISHES, payload: message });
  }
}

function* requestDeleteMasterTagDishes(action: Record<string, any>): any {
  try {
    yield call(deleteMasterDishes, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_DISHES,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_DISHES, payload: message });
  }
}

function* requestCreateMasterDishes(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterDishes, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_DISHES,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_DISHES, payload: message });
  }
}

export function getDishesMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category`,
    withCredentials: true,
  });
}

export function createMasterDishes(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterDishes(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterDishes(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const dishesMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_DISHES, requestMasterDishes),
    takeLatest(REQUEST_CREATE_MASTER_DISHES, requestCreateMasterDishes),
    takeLatest(REQUEST_UPDATE_MASTER_DISHES, requestUpdateMasterTagDishes),
    takeLatest(REQUEST_DELETE_MASTER_DISHES, requestDeleteMasterTagDishes),
  ]);
};

export default dishesMasterSaga;
